<template>
    <div class="student-page">
        <div class="term-box">
            <div class="term-item">
                <div class="term-title">{{$t('c.operatorLevel')}}</div>
                <div class="term-content">
                    <label :class="{'active': formSearch.forLevels.indexOf(0) > -1}">
                        <span>{{$t('c.all')}}</span>
                        <input type="checkbox" v-model="formSearch.forLevels" :value="0"
                               @change="checkboxAll('forLevels')">
                    </label>
                    <label v-for="item in forLevelMenu"
                           :class="{'active': formSearch.forLevels.indexOf(item.id) > -1, 'disabled': formSearch.forLevels.indexOf(0) > -1}"
                           :key="item.id">
                        <span>{{item.value}}</span>
                        <input type="checkbox" v-model="formSearch.forLevels" :value="item.id"
                               @change="choose('forLevels', 'forLevelMenu')"
                               :disabled="formSearch.forLevels.indexOf(0) > -1">
                    </label>
                </div>
            </div>

            <div class="term-item">
                <div class="term-title">{{$t('c.difficulty')}}</div>
                <div class="term-content">
                    <label :class="{'active': formSearch.difficulties.indexOf(0) > -1}">
                        <span>{{$t('c.all')}}</span>
                        <input type="checkbox" v-model="formSearch.difficulties" :value="0"
                               @change="checkboxAll('difficulties')">
                    </label>
                    <label v-for="item in difficultyMenu"
                           :class="{'active': formSearch.difficulties.indexOf(item.id) > -1, 'disabled': formSearch.difficulties.indexOf(0) > -1}"
                           :key="item.id">
                        <span>{{item.value}}</span>
                        <input type="checkbox" v-model="formSearch.difficulties" :value="item.id"
                               @change="choose('difficulties', 'difficultyMenu')"
                               :disabled="formSearch.difficulties.indexOf(0) > -1">
                    </label>
                </div>
            </div>
            <div class="term-item">
                <div class="term-title">{{$t('paper.questionType')}}</div>
                <div class="term-content">
                    <label :class="{'active': formSearch.topicTypes.indexOf(0) > -1}">
                        <span>{{$t('c.all')}}</span>
                        <input type="checkbox" v-model="formSearch.topicTypes" :value="0"
                               @change="checkboxAll('topicTypes')">
                    </label>
                    <label v-for="item in topicTypeMenu"
                           :class="{'active': formSearch.topicTypes.indexOf(item.id) > -1, 'disabled': formSearch.topicTypes.indexOf(0) > -1}"
                           :key="item.id">
                        <span>{{item.value}}</span>
                        <input type="checkbox" v-model="formSearch.topicTypes" :value="item.id"
                               @change="choose('topicTypes', 'topicTypeMenu')"
                               :disabled="formSearch.topicTypes.indexOf(0) > -1">
                    </label>
                </div>
            </div>

            <div class="term-item">
                <div class="term-title">{{$t('c.knowledgePoint')}}</div>
                <div class="term-content" style="padding: 0;">
                    <div class="term-parent">
                        <label :class="{'active': formSearch.knowledges.indexOf(0) > -1}">
                            <span>{{$t('c.all')}}</span>
                            <input type="checkbox" v-model="formSearch.knowledges" :value="0"
                                   @change="checkboxAll('knowledges')">
                        </label>
                        <template v-for="item in knowledgeMenu['Theory']">
                            <!-- 无子菜单的元素 -->
                            <label v-if="!item.children" :key="item.id"
                                   :class="{'active': formSearch.knowledges.indexOf(item.id) > -1,
                                            'disabled': formSearch.knowledges.indexOf(0) > -1}">
                                <span>{{item.value}}</span>
                                <input type="checkbox" v-model="formSearch.knowledges" :value="item.id"
                                       :disabled="formSearch.knowledges.indexOf(0) > -1">
                            </label>
                            <!-- 有子菜单的父级元素 -->
                            <div v-else class="label-parent" :key="item.id"
                                 :class="{'unfold': childData && parentID === item.id,
                                          'active': formSearch.knowledges.indexOf(item.id) > -1,
                                          'disabled': formSearch.knowledges.indexOf(0) > -1}"
                                 @click="toggleChildren(item.id, $event)">
                                <span>{{item.value}}</span>
                                <i class="nucfont inuc-angle-right"></i>
                                <el-badge class="mark" :value="selectedChildIDArr[item.id] && selectedChildIDArr[item.id].length"/>
                                <input type="checkbox" v-model="formSearch.knowledges" :value="item.id">
                            </div>
                        </template>
                    </div>
                    <!-- 子菜单 -->
                    <div class="term-children" :parent="parentID" v-if="childData">
                        <label @click="childCheckAll" :class="{'disabled': formSearch.knowledges.indexOf(0) > -1}">
                            <span>{{$t('c.all')}}</span>
                        </label>
                        <label v-for="item in childData"
                               :class="{'active': formSearch.knowledges.indexOf(item.id) > -1, 'disabled': formSearch.knowledges.indexOf(0) > -1}"
                               :key="item.id">
                            <span>{{item.value}}</span>
                            <input type="checkbox" v-model="formSearch.knowledges" :value="item.id"
                                   :disabled="formSearch.knowledges.indexOf(0) > -1">
                        </label>
                    </div>
                </div>
            </div>

            <div class="term-item">
                <div class="term-title">{{$t('count.quantity')}}</div>
                <div class="item-count">
                    <el-slider
                        v-model="formSearch.count"
                        :min="0"
                        :max="stock"
                        :disabled="!stock"
                        :step="5"
                        show-stops
                        show-input
                        @change="sliderChange"
                    >
                    </el-slider>
                    <p>/ <span style="font-size: 12px;">{{stock}}</span></p>
                </div>
            </div>
        </div>

        <div class="btn-group">
            <el-button type="primary" @click="startPractice" :disabled="formSearch.count === 0">
                {{$t('stu.startPractice')}}

            </el-button>
        </div>

        <paper-practice
            v-if="examData"
            :examData="examData"
            @close="onPaperClose"
            @close-result="onResultClose"
        >
        </paper-practice>

        <paper-view
            v-if="paperShow"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        >
        </paper-view>

        <div class="fullscreen-wrapper" v-if="loading" v-loading="true">
            <p>{{$t('stu.loadingExamTip')}}</p>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import {screenfull} from '@/utils'
    import SelectMultiKnowledge from '@/components/SelectMultiKnowledge';
    import {mapGetters} from 'vuex';
    import PaperPractice from '@/components/Paper/PaperPractice';
    import paperView from '@/components/Paper/PaperView';

    export default {
        components: {
            SelectMultiKnowledge,
            PaperPractice,
            paperView
        },
        data() {
            return {
                formSearch: {
                    forLevels: [],
                    difficulties: [],
                    knowledges: [],
                    topicTypes: [],
                    count: 20
                },
                stock: 100,
                parentID: 0,
                examData: null,
                loading: false,

                paperShow: false,
                paperInfo: {},
                topicData: []
            }
        },
        created() {
            this.queryStock();

            this.$store.dispatch('getForLevelMenu');
            this.$store.dispatch('getDifficultyMenu');
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Theory'
            });
            this.$store.dispatch('getTopicTypeMenu').then(v => {
                let arr = v.filter(obj => {
                    return (obj.value !== 'CT') && (obj.value !== 'DR')
                })
                this.$store.commit('getTopicTypeMenu', arr)
            });
        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'difficultyMenu',
                'knowledgeMenu',
                'topicTypeMenu',
                'wsTrainee',
            ]),
            childData() {
                let data = null;
                let parentData = this.knowledgeMenu['Theory'].find(v => v.id === this.parentID);

                if (parentData) {
                    data = parentData.children;
                }

                return data;
            },
            selectedChildIDArr() {
                let obj = {};

                this.knowledgeMenu['Theory'].forEach(v => {
                    if (v.children) {
                        let idArr = v.children.map(item => item.id);
                        this.formSearch.knowledges.forEach(id => {
                            if (idArr.indexOf(id) > -1) {
                                if (!obj[v.id]) obj[v.id] = [];
                                obj[v.id].push(id)
                            }
                        })
                    }
                })

                return obj;
            }
        },
        methods: {
            checkboxAll(name) {
                if (this.formSearch[name].indexOf(0) > -1) {
                    this.formSearch[name] = [0];
                }

                if (name === 'knowledges') this.fixBug();
            },
            choose(name, listName) {
                if (this.formSearch[name].length === this[listName].length) {
                    this.formSearch[name] = [0];
                }
            },

            toggleChildren(id, e) {
                this.parentID = id;

                let $parent = $(e.target).closest('.label-parent');
                let $child = $(e.target).closest('.term-content').find('.term-children');

                // 如果之前的状态是展开并且点击本身
                if ($child.is(":visible")) {
                    if (id == $child.attr('parent')) {
                        this.$nextTick(() => {
                            $child.hide();
                            $parent.removeClass('unfold');
                        })
                    }
                } else {
                    $child.show();
                    $parent.addClass('unfold');
                }
            },
            childCheckAll() {
                let childIDArr = this.childData && this.childData.map(v => v.id);
                let selectedChildrenNum = this.formSearch.knowledges.filter(v => childIDArr.indexOf(v) > -1).length;

                if (selectedChildrenNum === this.childData.length) {
                    this.childData.forEach(v => {
                        this.formSearch.knowledges.splice(this.formSearch.knowledges.indexOf(v.id), 1);
                    })
                } else {
                    this.childData.forEach(v => {
                        if (this.formSearch.knowledges.indexOf(v.id) < 0) {
                            this.formSearch.knowledges.push(v.id)
                        }
                    })
                }
            },

            queryStock() {
                let queryData = {...this.formSearch};
                delete queryData.count;

                ['forLevels', 'difficulties', 'knowledges','topicTypes'].forEach(v => {
                    if (this.formSearch[v].length == 1 && this.formSearch[v][0] == 0) {
                        delete queryData[v];
                    }
                });

                api.getTheoryStudyStock(queryData).then(res => {
                    if (!res.package) {
                        this.stock = 0;
                        this.formSearch.count = 0;
                        return;
                    }

                    this.stock = res.package > 100 ? 100 : res.package;
                    this.formSearch.count = 20;
                });
            },

            startPractice() {
                let queryData = {...this.formSearch};

                ['forLevels', 'difficulties', 'knowledges','topicTypes'].forEach(v => {
                    if (this.formSearch[v].length == 1 && this.formSearch[v][0] == 0) {
                        delete queryData[v];
                    }
                });

                this.loading = true;
                screenfull.request();

                api.startTheoryPractice(queryData).then(res => {
                    setTimeout(() => {
                        this.examData = res.package;
                        this.loading = false;
                    }, 500)

                }).catch(() => {
                    screenfull.exit();
                    this.loading = false;
                });

                // signalR:记录“练习”行为
                this.wsTrainee.send('SJoinPractice')
            },

            /**
             * 6.13 修复bug：知识点点击全部后，会给最近点击过的label-parent加上.unfold
             */
            fixBug() {
                this.$nextTick(() => {
                    if (!$('.term-children').is(':visible')) {
                        $('.label-parent').removeClass('unfold')
                    }
                })
            },
            sliderChange(val) {
                if (val%1) {
                    this.formSearch.count = Math.round(val);
                }
            },

            onPaperClose() {
                this.examData = null;
                this.paperShow = false;

                // signalR:记录“退出练习”行为
                this.wsTrainee.send('SLeavePractice')
            },
            onResultClose(id) {
                this.examData = null;
                this.paperShow = true;

                api.theoryStudyDetail(id).then(res => {
                    this.paperInfo = res.package;

                    let topicData = [];

                    res.package.topics.forEach(item => {
                        topicData.push({
                            topic: item,
                            topicID: item.id,
                            key: false,
                            score: 0
                        })
                    });

                    this.topicData = topicData;
                }).catch(error => {
                    this.paperShow = false;
                    screenfull.exit();
                });

            },
        },
        watch: {
            "formSearch.forLevels"(val) {
                this.queryStock();
            },
            "formSearch.difficulties"(val) {
                this.queryStock();
            },
            "formSearch.topicTypes"(val) {
                this.queryStock();
            },
            "formSearch.knowledges"(val) {
                this.queryStock();

                if (!this.childData) return;

                // 激活/取消父级的勾选状态
                let childIDArr = this.childData && this.childData.map(v => v.id);
                let selectedChildrenNum = this.formSearch.knowledges.filter(v => childIDArr.indexOf(v) > -1).length;

                if (selectedChildrenNum === this.childData.length) {
                    if (val.indexOf(this.parentID) < 0) {
                        this.formSearch.knowledges.push(this.parentID);
                    }
                } else {
                    if (val.indexOf(this.parentID) > -1) {
                        this.formSearch.knowledges.splice(val.indexOf(this.parentID), 1);
                    }
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .student-page {
        margin-top: 70px;
    }

    .term-box {
        box-shadow: 0 3px 20px #c5d0dd;
        user-select: none;
    }

    .term-item {
        display: flex;
        border-bottom: 1px solid #dedede;
    }

    .term-title {
        width: 150px;
        line-height: 56px;
        font-size: 17px;
        text-align: center;
        background-color: #F4F3F8;
        letter-spacing: .5px;
    }

    //$c-active: #2E7FAA;

    .term-content {
        padding: 15px 15px 0 15px;
        flex: 1;

        label {
            position: relative;
            display: inline-block;
            padding: 0 10px;
            margin-left: 20px;
            margin-bottom: 15px;
            line-height: 26px;
            border: 1px solid transparent;
            background-color: transparent;
            border-radius: 13px;
            cursor: pointer;

            > input {
                position: absolute;
                clip: rect(0, 0, 0, 0);
            }

            &.active {
                color: #fff;
                border-color: $color-theme;
                background-color: $color-theme;
            }

            &.disabled {
                color: #bbb;
                cursor: not-allowed;
            }
        }

        .label-parent {
            @extend label;
            position: relative;

            .nucfont {
                position: absolute;
                right: -10px;
                top: 0;
                font-size: 20px;
                color: #666;
                transition: transform .3s;
            }

            &.unfold {
                font-weight: 600;
                .nucfont {
                    transform: rotate(90deg);
                }
            }

            &.active .nucfont {
                right: -20px;
            }
        }

        .term-parent {
            padding: 15px 15px 0 15px;
        }

        .term-children {
            padding: 15px 15px 0 15px;
            background-color: #f9f9fd;
            border-top: 1px dashed #ccc;

            label:first-child.disabled {
                pointer-events: none;
            }
        }
    }

    .item-count {
        display: flex;
        padding-left: 40px;

        .el-slider {
            padding-top: 10px;
            width: 480px;
        }

        > p {
            margin-left: 16px;
            line-height: 56px;
            font-weight: 600;
        }
    }

    .btn-group {
        margin-top: 70px;
        text-align: center;

        button {
            padding: 15px 40px;
            font-size: 16px;
            letter-spacing: 1px;
        }
    }

    .fullscreen-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 3000;

        > p {
            position: absolute;
            top: 53%;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: #000;
            z-index: 9000;
        }
    }
</style>
<style lang="scss">
    .item-count .el-slider {
        input {
            font-weight: 600;
            font-size: 15px;
        }
    }
</style>
